var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreshdesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.97236 7.50111e-05H13.9816C14.2473 -0.00222543 14.5108 0.0484079 14.7567 0.149022C15.0026 0.249635 15.226 0.398215 15.4139 0.58609C15.6018 0.773965 15.7504 0.997375 15.851 1.24328C15.9516 1.48919 16.0022 1.75268 15.9999 2.01836V8.02739C15.9994 10.1417 15.1592 12.1693 13.6642 13.6643C12.1691 15.1593 10.1414 15.9995 8.02707 16H7.98173C6.93402 16.0012 5.89635 15.7959 4.92801 15.3959C3.95968 14.9959 3.07965 14.409 2.33823 13.6687C1.59686 12.9284 1.00874 12.0492 0.607523 11.0814C0.206304 10.1135 -0.000140664 9.07607 7.19075e-08 8.02837C7.19075e-08 3.61032 3.56353 0.046897 7.97285 0.00155327L7.97236 7.50111e-05Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53255 4.01569C7.60086 4.01569 6.70733 4.40874 6.04852 5.10837C5.38972 5.80801 5.01961 6.75691 5.01961 7.74635V10.283C5.02658 10.6097 5.15191 10.921 5.36952 11.1521C5.58712 11.3832 5.88025 11.5163 6.18791 11.5237H7.18182V8.61264H5.83959V7.79804C5.92135 6.26372 7.11659 5.06417 8.56374 5.06417C10.0109 5.06417 11.2104 6.26874 11.2879 7.79804V8.61264H9.92817V11.5237H10.8261V11.5699C10.8216 11.8728 10.7063 12.162 10.5046 12.3762C10.3028 12.5905 10.0305 12.7129 9.74527 12.7177H8.67244C8.58548 12.7177 8.48954 12.7639 8.48954 12.8567C8.49426 12.9571 8.57319 13.0465 8.67244 13.051H9.75331C10.1225 13.0485 10.4758 12.8916 10.7369 12.6144C10.9979 12.3372 11.1456 11.9619 11.148 11.5699V11.4775C11.4043 11.4154 11.633 11.2622 11.7962 11.0434C11.9595 10.8246 12.0476 10.5531 12.046 10.2739V7.79302C12.0946 5.69104 10.5256 4.01569 8.53255 4.01569Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreshdesk);
export default __webpack_public_path__ + "static/media/freshdesk.a74d737beb5b6e779e65ab6b8b5278b9.svg";
export { ForwardRef as ReactComponent };